/**
 * Centralized token storage utility.
 *
 * Currently uses localStorage for session persistence across page refreshes.
 * To switch to httpOnly cookies or in-memory storage, update these functions.
 *
 * Security note: localStorage is accessible to any JS on the page (XSS risk).
 * For production hardening, migrate to httpOnly cookie-based auth on the backend.
 */

const TOKEN_KEY = 'macroflare_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function hasToken() {
  return !!localStorage.getItem(TOKEN_KEY);
}
